import React, { useContext, Dispatch, useState,useEffect, useRef, SetStateAction, useMemo, startTransition, Suspense } from "react";
import { Link,useNavigate } from "react-router-dom";
import './TopBar.css'
import logoWhite from '../../../image/logo/logoWhite.webp'
import { FaMapMarkerAlt, FaLocationArrow} from "react-icons/fa";
import { LiaSlidersHSolid } from "react-icons/lia";
import { AppContext } from "../../../context/AppContext";
import { Restaurant,Coordonates, slugify, trackGaEventOncePerSession, getPageContextAnalytics } from "../../../components/types/types";
import axios from "axios";
import { TfiClose } from "react-icons/tfi";
import IconConnection from "../../../components/iconConnection/iconConnection";
import { ImMap2 } from "react-icons/im";
import { GoSearch } from "react-icons/go";
import { PiCalendarDotsLight } from "react-icons/pi";
import { CiClock2 } from "react-icons/ci";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import ChunkErrorBoundary from "../../../components/hook/chunkErrorBoundary";

const  RestoSearchBar = React.lazy(() => import("../../../components/restoSearchBar/restoSearchBar"));
const Calendar = React.lazy(() => import("../../../components/CalandarTopBar/calandarLazy"));
const TIME_FILTERS = new Set(["Ouvert ce midi","Ouvert ce soir"]);
function clearTimeFilters(setListFilter:Dispatch<SetStateAction<(string | number | [number, number])[]>>, currentList: (string|number|[number,number])[]) {
  if (!currentList.some(x => TIME_FILTERS.has(x as string))) return false;
  setListFilter(prev => prev.filter(x => !TIME_FILTERS.has(x as string)));
  return true;
}
function clearProximity(setListFilter:Dispatch<SetStateAction<(string | number | [number, number])[]>>, currentList: (string|number|[number,number])[]) {
 if (currentList.includes('A proximité')) {
    setListFilter(prev => prev.filter(x => x !== 'A proximité'));
    return
  } else return; 
}

interface ContainerShowCityProps {
    clickProximity?: () => void,
    suggestionsCity: villesProps[],
    setShowCity: Dispatch<SetStateAction<boolean>>,
    setSearchCity: Dispatch<SetStateAction<string>>,
    clearProximity:() => void
}

export const ContainerShowCity:React.FC<ContainerShowCityProps> = ({clickProximity,suggestionsCity,setShowCity,setSearchCity,clearProximity}) => {
    const navigate = useNavigate()
    return (
        <>
            {clickProximity && <div className="elem pointer" onClick={() => {clickProximity();navigate('/restaurants-a-proximite')}}>
                <FaLocationArrow size={13} />
                <p key={"city-1"}>A proximité</p>
            </div>}
            {
                suggestionsCity.length > 0 && <>
                    <div className="borderCity"></div>
                    {suggestionsCity.map((ville, index) => (
                        <div className="elem pointer" key={"suggestionCity"+index} onClick={() => {navigate(`/${slugify(ville.name)}`);setShowCity(false);setSearchCity(ville.name);clearProximity()}}>
                            <FaMapMarkerAlt size={15} />
                            <p key={"city-"+index}>{ville.name}</p>
                        </div>
                    ))}
                </>
            }
        </>
    )
}

interface ContainerSuggestionProps {
    suggestions:Restaurant[],
}

const ContainerSuggestion:React.FC<ContainerSuggestionProps> = ({suggestions}) => {
    return (
        <>
            {
                suggestions.map((elem,id) => {
                    return <div key={"suggestion"+id} style={{width:'100%'}}>
                        <ChunkErrorBoundary>
                         <Suspense fallback={null}>
                    <RestoSearchBar name={elem.name} id_url={elem.id_url} city={elem.address[1]} devanture={elem.devanture} type={elem.type} nbrReview={elem.nbr_review} note={elem.note}/>
                    </Suspense>
                    </ChunkErrorBoundary>
                    {id < suggestions.length -1 && <div className="border"></div>}
                    </div>
                })
            }
        </>
    )
}

interface ContainerCalendarProps {
    today: Date,
    maxDate:Date,
    activeMonth:Date,
    setActiveMonth:Dispatch<SetStateAction<Date>>,
    setShowCalendar:Dispatch<SetStateAction<boolean>>
}
const ContainerCalendar:React.FC<ContainerCalendarProps> = ({today,maxDate,activeMonth,setActiveMonth,setShowCalendar}) => {
    const {setDate_selected,date_selected,setFilterChoose,filterChoose} = useContext(AppContext)
    const fourMonthsLater = new Date();
    fourMonthsLater.setMonth(today.getMonth() + 3);

    const handleActiveStartDateChange = ({ activeStartDate }: { activeStartDate: Date | null }) => {
        if (activeStartDate) {
            setActiveMonth(activeStartDate); 
        }
    };
    const handleClickDay = (date:Date) => {
        setShowCalendar(false)
        clearTimeFilters(setFilterChoose,filterChoose)
        if(date_selected?.getTime() === date.getTime()) setDate_selected(null)
        else setDate_selected(date)
      };
    return (
        <ChunkErrorBoundary>
        <Suspense fallback={null}>
            <Calendar
                minDate={today}
                maxDate={maxDate}
                value={date_selected || today}
                onActiveStartDateChange={handleActiveStartDateChange}
                onClickDay={(date) => {
                    handleClickDay(date);
                }}
                tileClassName={({ date, view }: TileClassNameProps) => {
                    if (view === "month") {
                        const isSameMonth =
                        date.getMonth() === activeMonth.getMonth() &&
                        date.getFullYear() === activeMonth.getFullYear();

                        if (
                            date_selected &&
                            date.getDate() === date_selected.getDate() &&
                            date.getMonth() === date_selected.getMonth() &&
                            date.getFullYear() === date_selected.getFullYear()
                            ) {
                            return "date_select";
                        }

                        if (
                            date.getDate() === today.getDate() &&
                            date.getMonth() === today.getMonth() &&
                            date.getFullYear() === today.getFullYear()
                            ) {
                            return "current_Date";
                        }
                            

                        if (date < today || date > fourMonthsLater) {
                            return "lockDay";
                        }

                        if (
                            (date.getDay() === 6 || date.getDay() === 0) &&
                            isSameMonth &&
                            date.getTime() < maxDate.getTime()
                            ) {
                        return "weekEnd";
                        }

                        return "futureDay";
                    }

                    return null;
                }}
                view="month"
                showNeighboringMonth={true}
                navigationLabel={({ label }) => (
                    <span className="midTitle" >
                        {label.charAt(0).toUpperCase() + label.slice(1)}
                    </span>
                )}
            />     
        </Suspense>
    </ChunkErrorBoundary>
    )
}
function useLockScrollChaining(ref: React.RefObject<HTMLElement>,active: boolean) {
  const startY = useRef(0);

  useEffect(() => {
    if (!active) return;
    const el = ref.current;
    if (!el) return;

    const onTouchStart = (e: TouchEvent) => {
      if (e.touches.length !== 1) return;
      startY.current = e.touches[0].clientY;
      if (el.scrollHeight > el.clientHeight) {
        if (el.scrollTop <= 0) el.scrollTop = 1;
        const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight;
        if (atBottom) el.scrollTop = el.scrollTop - 1;
      }
    };

    const onTouchMove = (e: TouchEvent) => {
      if (e.touches.length !== 1) return;

      const canScroll = el.scrollHeight > el.clientHeight;
      if (!canScroll) {
        e.preventDefault();
        return;
      }
      const currentY = e.touches[0].clientY;
      const deltaY = currentY - startY.current; 
      const atTop = el.scrollTop <= 0;
      const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;

      const pullingDownAtTop = atTop && deltaY > 0;
      const pushingUpAtBottom = atBottom && deltaY < 0;

      if (pullingDownAtTop || pushingUpAtBottom) {
        e.preventDefault();
      }
    };

    el.addEventListener("touchstart", onTouchStart, { passive: true });
    el.addEventListener("touchmove", onTouchMove, { passive: false });

    return () => {
      el.removeEventListener("touchstart", onTouchStart);
      el.removeEventListener("touchmove", onTouchMove);
    };
  }, [ref, active]);
}
function useAutoHideTopbar(isMobile: boolean,disabled:boolean,noAutoHideUntilRef?: React.MutableRefObject<number>) {
  const [open, setOpen] = useState(true);
  
  const lockedUntilRef = useRef(0);
  const lockKeepClosedBriefly = () => {
    lockedUntilRef.current = Date.now() + 700; 
  };
  const [chevron, setChevron] = useState(false);

  const lastYRef = useRef(0);
  const rafRef = useRef<number | null>(null);
  const yRef = useRef(0);
  
  const topStickyUntilRef = useRef(0);
  const upAccRef = useRef(0);
  const downAccRef = useRef(0);
  const lastDirTsRef = useRef(0);
    
  const OPEN_AT_TOP_Y = 80; 
  useEffect(() => {
    if (!isMobile || disabled) return;

    lastYRef.current = window.scrollY;
    yRef.current = window.scrollY;
    const onScroll = () => {
      if (rafRef.current != null) return;

      rafRef.current = requestAnimationFrame(() => {
        rafRef.current = null;

        const now = Date.now();
        const y = window.scrollY;
        if (y <= OPEN_AT_TOP_Y + 10) {
            lockedUntilRef.current = 0;    
            setChevron(false);
            setOpen(true);
            upAccRef.current = 0;
            downAccRef.current = 0;
            lastYRef.current = y;
            yRef.current = y;
            return;
        }
        if (now < lockedUntilRef.current) return;
        if (noAutoHideUntilRef?.current && now < noAutoHideUntilRef.current) {
            setChevron(false);
            setOpen(true);
            upAccRef.current = 0;
            downAccRef.current = 0;
            lastYRef.current = window.scrollY;
            yRef.current = window.scrollY;
            return;
        }

        const TOP_STICKY_Y = OPEN_AT_TOP_Y + 30; 
        if (y <= TOP_STICKY_Y) {
            topStickyUntilRef.current = now + 1000; 
        }

        if (now < topStickyUntilRef.current) {
            setChevron(false);
            setOpen(true);
            upAccRef.current = 0;    
            downAccRef.current = 0;
            yRef.current = y;
            lastYRef.current = y;
            return;
        }
        yRef.current = y;
        const lastY = lastYRef.current;
        const dy = y - lastY;

        const CLOSE_AFTER_Y = 160;   
        const MIN_DELTA = 8;     
        const nextChevron = y > CLOSE_AFTER_Y;
        setChevron(prev => (prev === nextChevron ? prev : nextChevron));

        if (y <= OPEN_AT_TOP_Y) {
          upAccRef.current = 0;
          downAccRef.current = 0;
          setOpen(true);
          lastYRef.current = y;
          return;
        }
        const DIR_WINDOW_MS = 250;
        if (now - lastDirTsRef.current > DIR_WINDOW_MS) {
          upAccRef.current = 0;
          downAccRef.current = 0;
        }
        const OPEN_UP_PX = 300;  
        const CLOSE_DOWN_PX = 45;

        if (Math.abs(dy) < MIN_DELTA) {
            lastYRef.current = y;
            return;
        }
        

        if (dy < 0) {
          lastDirTsRef.current = now;
          upAccRef.current += Math.abs(dy);
          downAccRef.current = 0;
          if (y > CLOSE_AFTER_Y && upAccRef.current >= OPEN_UP_PX) {
            setOpen(true);
            upAccRef.current = 0;
          }
        } else {
          lastDirTsRef.current = now;
          downAccRef.current += dy;
          upAccRef.current = 0;

          if (y > CLOSE_AFTER_Y && downAccRef.current >= CLOSE_DOWN_PX) {
            setOpen(false);
            downAccRef.current = 0;
          }
        }

        lastYRef.current = y;
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
}, [isMobile,disabled]);

  const toggleManually = () => {
    if (yRef.current <= OPEN_AT_TOP_Y) {
      lockedUntilRef.current = Date.now() + 200;
      setOpen(true);
      return;
    }
    lockedUntilRef.current = Date.now() + 600;
    setOpen(o => !o);
  };

  const lockAutoHideBriefly = () => {
    lockedUntilRef.current = Date.now() + 600;
  };

  return { open, chevron, toggleManually, lockAutoHideBriefly, setOpen, lockKeepClosedBriefly };
}

type TileClassNameProps = {
    date: Date;
    view: string;
  };

interface TopBarProps {
    listBase:Restaurant[],
    lengthResto:number
}


export interface villesProps {
    name:string,
    latitude:string,
    longitude:string,
}

const TopBar:React.FC<TopBarProps> = ({listBase}) => {

    const {valueSearchCity,setValueSearchCity,intentGoMap,setIntentGoMap,showFilterTel,filterChoose,setFilterChoose,setShowFilterTel,setCurrentHomePage,searchCity,setSearchCity,setCoordonates,setSearchValueHome,setDate_selected,date_selected,hour_selected,setHour_selected, setPreferencesCookies} = useContext(AppContext)

    const [valueSearchBar,setValueSearchBar] = useState('')
    const [suggestions, setSuggestions] = useState<Restaurant[]>([]);

    const ignoreAutoCloseUntilRef = useRef(0);

    const [activeTopBar,setActiveTopBar] = useState(false)

    const [suggestionsCity, setSuggestionsCity] = useState<villesProps[]>([])
    const [showSearch,setShowSearch] = useState(false)

    const [showCity,setShowCity] = useState(false)
    const [showCalendar,setShowCalendar] = useState<boolean>(false)
    const [showHour,setShowHour] = useState<boolean>(false)
    const [activeMonth, setActiveMonth] = useState(new Date());

    const restoSuggestionRef = useRef<HTMLDivElement>(null);
    const citySuggestionRef = useRef<HTMLDivElement>(null);
    useLockScrollChaining(restoSuggestionRef, showSearch && suggestions.length > 0);
    useLockScrollChaining(citySuggestionRef, showCity);
    
    const noAutoHideUntilRef = useRef(0);
    let windowInnerWidth = window.innerWidth
    const isSmallScreen = windowInnerWidth <= 1210; 
    const isMobile = windowInnerWidth <= 700; 
    const autoHideDisabled = showCity || showCalendar || showHour || showSearch;
    const { open, chevron, toggleManually, lockAutoHideBriefly, setOpen, lockKeepClosedBriefly } = useAutoHideTopbar(isMobile,autoHideDisabled,noAutoHideUntilRef);
    
    const ignoreScrollCloseRef = useRef(0);
    const ignoreFocusSideEffectsRef = useRef(0);
    const handleToggleManually= () => {
        ignoreScrollCloseRef.current = Date.now() + 800; 
        toggleManually();
    };

    useEffect(() => {
        if (!showCity && !showCalendar && !showHour && !showSearch) return;

        let ticking = false;
        let lastY = window.scrollY;

        const onScroll = () => {
            if (ticking) return;
            ticking = true;

            requestAnimationFrame(() => {
                ticking = false;
                if (Date.now() < ignoreAutoCloseUntilRef.current) return;

                const y = window.scrollY;
                if (y !== lastY && (showCity || showCalendar || showHour || showSearch)) {
                    setShowCity(false);
                    setShowCalendar(false);
                    setShowHour(false);
                    setShowSearch(false);
                    if (showSearch) setSuggestions([]);
                }
                lastY = y;
            });
        };

        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, [showCity, showCalendar, showHour,showSearch]);

    useEffect(() => {
        if (activeTopBar) {
            document.body.style.overflowY = 'hidden'
        } else {
            document.body.style.overflowY = 'auto'
        }
    
        return () => {
            document.body.style.overflowY = 'auto'
        };
    }, [activeTopBar])
   
    const justClickedCityRef = useRef(false)

    const today = new Date();
    const refIconCalendar = useRef<HTMLInputElement>(null)
    const refCalendar = useRef<HTMLInputElement>(null)
    const refIconHour = useRef<HTMLInputElement>(null)
    const refHour = useRef<HTMLInputElement>(null)
    const refSearch = useRef<HTMLInputElement>(null)
    const refCity = useRef<HTMLInputElement>(null)


    const refCalendarPhone = useRef<HTMLInputElement>(null)
    const refHourPhone = useRef<HTMLInputElement>(null)
    const refSearchPhone = useRef<HTMLInputElement>(null)
    const cityPhoneAreaRef = useRef<HTMLDivElement>(null);
    const searchPhoneBoxRef = useRef<HTMLDivElement>(null);
    const refCityPhone = useRef<HTMLInputElement>(null)

    const refInputSearchPhone = useRef<HTMLInputElement>(null)
    const refInputCityPhone = useRef<HTMLInputElement>(null)
    const blurMobileInputs = () => {
        refInputSearchPhone.current?.blur();
        refInputCityPhone.current?.blur();
    };
    useEffect(() => {
        if (window.innerWidth > 700) return;

        let raf: number | null = null;
        let lastY = window.scrollY;

        const onScroll = () => {
            if (raf != null) return;

            raf = requestAnimationFrame(() => {
                raf = null;
                if (Date.now() < ignoreScrollCloseRef.current) return;
                if (Date.now() < ignoreFocusSideEffectsRef.current) return;
                if (Date.now() < noAutoHideUntilRef.current) return;

                const y = window.scrollY;
                const dy = Math.abs(y - lastY);
                lastY = y;
                if (dy < 3) return;

                const isFocused =
                    document.activeElement === refInputSearchPhone.current ||
                    document.activeElement === refInputCityPhone.current;

                if (!isFocused) return;
                blurMobileInputs();
                setShowSearch(false);
                setSuggestions([]);
                setShowCity(false);
                setShowCalendar(false);
                setShowHour(false);
                if (y <= 120) {
                    setOpen(true);
                    return;
                }
                lockKeepClosedBriefly();
                setOpen(false);
            });
        };

        window.addEventListener("scroll", onScroll, { passive: true });
        return () => {
            window.removeEventListener("scroll", onScroll);
            if (raf != null) cancelAnimationFrame(raf);
        };
    }, [setOpen, lockKeepClosedBriefly]);

    useEffect(() => {
        if (valueSearchCity.length > 0) { 
          axios.post(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/getVille`, { name: valueSearchCity })
            .then(response => {
                setSuggestionsCity(response.data); 
            })
            .catch(error => {
              console.error('Erreur lors de la recherche des villes:', error);
            })
        } else {
          setSuggestionsCity([]); 
        }
      }, [valueSearchCity]);


    useEffect(() => {
        const timeout = setTimeout(() => {
            if (!valueSearchBar) {
                setSuggestions([]);
                return;
            }
            const lowerCaseSearch = valueSearchBar.toLowerCase().replace(/[\u2019\u2018\u2032\u00B4`]/g, "'") ;
            const matches = listBase.reduce<{
                start: Restaurant[];
                includes: Restaurant[];
            }>(
                (acc, elem) => {
                    const name = elem.name.toLowerCase().replace(/[\u2019\u2018\u2032\u00B4`]/g, "'");
                    if (name.startsWith(lowerCaseSearch)) {
                        acc.start.push(elem);
                    } else if (name.includes(lowerCaseSearch)) {
                        acc.includes.push(elem);
                    }
                    return acc;
                },
                { start: [], includes: [] }
            );
            setSuggestions([...matches.start, ...matches.includes].slice(0, 5));
        }, 300);
        return () => clearTimeout(timeout);
    }, [valueSearchBar]);
    

    const handleClick = () => {
        const nextValue = !showFilterTel;
        if(nextValue) {
            const pageContext = getPageContextAnalytics();
            trackGaEventOncePerSession(
                `qr_filter_bar_open_sent_${pageContext}`,
                "qr_filter_bar_open",
                {
                page_context: pageContext
                }
            );
        }

        setShowFilterTel(nextValue);
    }; 

    const changeSearchBar = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValueSearchBar(event.target.value)
    }
    const changeSearchCityBar = (event: React.ChangeEvent<HTMLInputElement>) => {
        const v = event.target.value;
        setValueSearchCity(v)
        if(v === '') {
            setSearchCity('')
            setCoordonates({latitude:"",longitude:""})
        }
    }
    const blurSearchCityBar = (event: React.FocusEvent<HTMLInputElement>) => {
        const v = event.target.value;
        if(v === '') {
            noAutoHideUntilRef.current = Date.now() + 1000;
            setOpen(true);
            navigate('/')
        }
    }
    const changeSearchTopBar = (newElem:string) => {
        setShowSearch(false)
        setSearchValueHome(newElem)
        setCurrentHomePage(1)
    }
    const launchSearch = () => {
        setShowSearch(false)
        setSearchValueHome(valueSearchBar)
        setCurrentHomePage(1)
    }


    const inputSearchKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if(event.key === 'Enter') changeSearchTopBar((event.target as HTMLInputElement).value)
    }

    const handleClickInput = () => {
        ignoreAutoCloseUntilRef.current = Date.now() + 600; 
        setShowCity(false);
        setShowCalendar(false);
        setShowHour(false);
        
        startTransition(() => {setShowSearch(true)});
        if (window.innerWidth > 700) {
            document.addEventListener('mouseup', handleClickOutsideSearch);
        }
    }

    const handleClickCity = () => {
        ignoreAutoCloseUntilRef.current = Date.now() + 600;
        justClickedCityRef.current = true;
        setShowCity(true)
        if (window.innerWidth > 768) {
            setTimeout(() => {
                document.addEventListener('mouseup', handleClickOutsideCity);
            }, 50);
        }
        setTimeout(() => {
            justClickedCityRef.current = false;
        }, 300);
    }
    const handleClickOutsideCity = (event: MouseEvent) => {
        if (refCity.current && !refCity.current.contains(event.target as Node)) {
            setShowCity(false)
            document.removeEventListener('mouseup', handleClickOutsideCity);
        }
    }
    const handleClickOutsideSearch= (event: MouseEvent) => {
        if (refSearch.current && !refSearch.current.contains(event.target as Node) ) {
            setShowSearch(false)
            ;
        }
    }
    useEffect(() => {
        if (showCalendar) {
          document.addEventListener('mouseup', handleClickOutsideCalendar);
        } 
        else {
            document.removeEventListener('mouseup', handleClickOutsideSearch)
        }

      }, [showCalendar]);
      const handleClickOutsideCalendar = (event: MouseEvent) => {
        if (refCalendar.current && !refCalendar.current.contains(event.target as Node) && refIconCalendar.current && !refIconCalendar.current.contains(event.target as Node) && refCalendarPhone.current && !refCalendarPhone.current.contains(event.target as Node) ) {
          setShowCalendar(false); 
          document.removeEventListener('mouseup', handleClickOutsideSearch)
        }
      };
    useEffect(() => {
        if (showHour) {
          document.addEventListener('mouseup', handleClickOutsideHour);
        } 
        else {
            document.removeEventListener('mouseup', handleClickOutsideHour)
        }

      }, [showHour]);
      const handleClickOutsideHour = (event: MouseEvent) => {
        if (refHour.current && !refHour.current.contains(event.target as Node) && refIconHour.current && !refIconHour.current.contains(event.target as Node) && refHourPhone.current && !refHourPhone.current.contains(event.target as Node)) {
          setShowHour(false); 
          document.removeEventListener('mouseup', handleClickOutsideSearch)
        }
      };


    const clickProximity = () => {
        setValueSearchCity("Chargement...")
        const inputCity = document.querySelector('.inputCity') as HTMLInputElement;
        inputCity.classList.add('loading');
        inputCity.disabled = true;
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const userLocation:Coordonates = {
                        latitude: position.coords.latitude.toString(),
                        longitude: position.coords.longitude.toString(),
                    };
                    setSearchCity("A proximité");
                    setValueSearchCity("A proximité")
                    setCoordonates(userLocation); 
                    inputCity.disabled = false;
                    inputCity.classList.remove('loading');
                },

                (error) => {
                    console.error("Erreur lors de la récupération de la localisation :", error.message);
                    if(searchCity === "" ) {
                        setSearchCity("");
                        setValueSearchCity("")
                    }
                    else {
                        setValueSearchCity(searchCity)
                    }
                    inputCity.classList.remove('loading');
                    inputCity.disabled = false;
                }
            );
        } else {
            console.error("Geolocation n'est pas supportée par ce navigateur.");
            setSearchCity("");
            setValueSearchCity("")
        }
        setShowCity(false)
        document.removeEventListener('mouseup', handleClickOutsideCity);
    }

        const generateTimeSlots = () => {
            const times = [];
            for (let h = 0; h < 24; h++) {
                for (let m = 0; m < 60; m += 30) {
                    const hour = h.toString().padStart(2, "0");
                    const minute = m.toString().padStart(2, "0");
                    times.push(`${hour}h${minute}`);
                }
            }
            return times;
        };
        const timeSlots = useMemo(() => generateTimeSlots(), []);

        const getClosestTimeSlot = () => {
            if(hour_selected) return hour_selected
            else {
                const now = new Date();
                const hours = now.getHours();
                const minutes = now.getMinutes();
                const roundedMinutes = minutes < 30 ? "30" : "00";
                const nextHour = minutes < 30 ? hours : (hours + 1) % 24;
                return `${nextHour.toString().padStart(2, "0")}h${roundedMinutes}`;
           }
        };
    
        useEffect(() => {
            if (showHour) {
                const closestTime = getClosestTimeSlot(); 
                const containerPhone = document.getElementById("containerHourTopBarPhone");
                const container = document.getElementById("containerHourTopBar");
                const hour = parseInt(closestTime.split("h")[0], 10) || 0;
                
                if (container) {
                    const elementHeight = 90;
                    const scrollTop = hour * elementHeight + (hour > 15 ? 100 : 0);
                    container.scrollTo({
                        top: scrollTop,
                        behavior: "auto",
                    });
                }
                if (containerPhone) {
                    const elementHeight = 80;
                    const scrollTop = hour * elementHeight + (hour > 15 ? (hour > 20 ? 90 : 75) : 0);
                    containerPhone.scrollTo({
                        top: scrollTop,
                        behavior: "auto",
                    });
                }
            }
        }, [showHour]);
    
        

    const handleCalendar = () => {
        setShowCity(false)
        startTransition(() => {setShowCalendar(!showCalendar)});
        setActiveMonth(date_selected ? date_selected : new Date)
    }

    const formatSelectedDate = (date: Date | null): string => {
        if (!date) {
            return "Date"; 
        }
    
        const today = new Date();
        if (
            date.getDate() === today.getDate() &&
            date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear()
        ) {
            return "Auj.";
        }
        const showDate =  date.toLocaleDateString("fr-FR", {
            day: "numeric",
            month: "short",
            
        })
        const [day,month] = showDate.split(" ")

        return `${day} ${month[0].toUpperCase()+month.slice(1)} `
        
    };

    const maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 3);
    useEffect(() => {
        if(showHour ||showCalendar || (showSearch && valueSearchBar) || (showCity && valueSearchCity)) {
            setActiveTopBar(true)
        }
        else setActiveTopBar(false)
        
    },[showCalendar,showHour,showCity,showSearch,valueSearchBar,valueSearchCity])

    const {setShowCookies} = useContext(AppContext)
    const navigate = useNavigate()

    const handleMap = () => {
        if (window.innerWidth <= 700) {
            lockKeepClosedBriefly();
        }
        const cookie = document.cookie.split('; ').find(row => row.startsWith('QUELRESTO_COOKIE='));
        if (cookie) {
            const cookieValue = cookie.split('=')[1];
            try {
                const decode = decodeURIComponent(cookieValue)
                const cookieData = JSON.parse(decode);
                if (cookieData['perform-analytics']) {
                    setShowFilterTel(false)
                    navigate(`/map?via=home`);
                } else {
                    setShowCookies(true)
                    setPreferencesCookies(true) 
                    setIntentGoMap(1)
                }
            } catch (error) {
                setShowCookies(true)
                setPreferencesCookies(true)
                setIntentGoMap(1)
            }
        } else {
            setShowCookies(true)
            setPreferencesCookies(true)
            setIntentGoMap(1)
        }
    }
    useEffect(() => {
        if(intentGoMap === 2) {
            setShowFilterTel(false)
            setIntentGoMap(0)
            navigate(`/map?via=home`);
        }
    },[intentGoMap])

    useEffect(() => {
        if (window.innerWidth > 700) return; 

        const onPointerDown = (e: PointerEvent) => {
            const t = e.target as Node;

            const inSearch = searchPhoneBoxRef.current?.contains(t);
            const inCity = cityPhoneAreaRef.current?.contains(t);

            const inCalendar = refCalendarPhone.current?.contains(t);
            const inHour = refHourPhone.current?.contains(t);

            if (!inSearch) {
            setShowSearch(false);
            setSuggestions([]);
            }
            if (!inCity) setShowCity(false);
            if (!inCalendar) setShowCalendar(false);
            if (!inHour) setShowHour(false);
        };

            document.addEventListener("pointerdown", onPointerDown, { passive: true });
            return () => document.removeEventListener("pointerdown", onPointerDown);
    }, []);

    return (

        <div className='DoubleTopBarHome'>
            <div className="TopBar" >
                <Link to={"/"} className={`containerLogo  ${open ? 'open' : 'closed'}`} onClick={() => {setSearchCity('');setValueSearchCity('');setCoordonates({latitude:"",longitude:""})}}>
                    <img className="logoTopBar" onClick={() => {window.scrollTo({ top: 0, behavior: 'smooth' });setCurrentHomePage(1)}} src={logoWhite} loading="lazy" alt="logo" />
                </Link>


                <div className={`containerSearchBarPhone  ${open ? 'open' : ''}`} >
                    <div className='firstInput primaryBack' onClick={() => {lockAutoHideBriefly(); setOpen(true); setShowSearch(true); ignoreFocusSideEffectsRef.current = Date.now() + 550;}} ref={searchPhoneBoxRef}>
                        <GoSearch color="black" className="searchIconPhone" size={20} />
                        <form onSubmit={(e) => {
                            e.preventDefault();
                            refInputSearchPhone.current?.blur();
                            changeSearchTopBar(valueSearchBar);
                        }} style={{width:'100%'}}>
                        <input type="search" ref={refInputSearchPhone} className='inputTopBar midText' enterKeyHint="search" placeholder="Rechercher un restaurant..." style={{backgroundColor:"transparent"}} value={valueSearchBar} onChange={changeSearchBar}  onKeyDown={(e) => {if (e.key === 'Enter') { const target = e.target as HTMLInputElement;target.blur(); launchSearch();}}} maxLength={50} onFocus={() => {
                        lockAutoHideBriefly();
                        setOpen(true);
                        ignoreAutoCloseUntilRef.current = Date.now() + 600;
                        ignoreFocusSideEffectsRef.current = Date.now() + 550;

                        setShowCity(false);
                        setShowCalendar(false);
                        setShowHour(false);

                        setShowSearch(true);
                    }}/></form>
                        {valueSearchBar && <TfiClose className="resetTopBar pointer" size={17} onClick={() => {setValueSearchBar("");changeSearchTopBar('')}}/> }  
                        {
                            showSearch && suggestions.length > 0 && <div ref={restoSuggestionRef} className="containerSuggestion primaryBack" >
                                <ContainerSuggestion suggestions={suggestions} />
                            </div>
                        }
                    </div>
                    <div className="secondInput primaryBack" ref={cityPhoneAreaRef} onClick={() => {lockAutoHideBriefly(); setOpen(true);}}>
                      
                        <FaMapMarkerAlt color="black" size={18} />
                        <input type="search" ref={refInputCityPhone} className="inputTopBar inputCity midText" enterKeyHint="search" id={"inputCity"} placeholder="Ville ..." style={{backgroundColor:"transparent"}} value={valueSearchCity} onChange={changeSearchCityBar} onBlur={blurSearchCityBar}  maxLength={50} autoComplete="new-password" name="q_addr" onFocus={(e) => {e.currentTarget.setAttribute('autocomplete', 'new-password');ignoreFocusSideEffectsRef.current = Date.now() + 800;handleClickCity()}}/>
                        {showCity && <div ref={citySuggestionRef} className="containerListCity smallText">
                                <ContainerShowCity setSearchCity={setValueSearchCity} clickProximity={clickProximity} suggestionsCity={suggestionsCity} setShowCity={setShowCity} clearProximity={() => {clearProximity(setFilterChoose,filterChoose)}}/>
                            </div>
                        }
                        
                        {valueSearchCity && <TfiClose className="resetTopBar pointer" size={15} onClick={(e) => { e.stopPropagation();e.preventDefault();clearProximity(setFilterChoose,filterChoose); navigate('/');setValueSearchCity(""); setSearchCity("") ;setCoordonates({latitude:"",longitude:""}) }}/> }
                        <div className="separation"></div>
                        <PiCalendarDotsLight color={date_selected ? '#cb9e3A' : 'black'} size={20} onClick={handleCalendar}/>
                        <div className="separation"></div>
                        <CiClock2 color={hour_selected ? '#cb9e3A' : 'black'} size={18} onClick={() => {setShowHour(!showHour);setShowCity(false)}} />

                        {
                        showCalendar && (
                            <div className="containerCalendar" ref={refCalendarPhone}>
                                <ContainerCalendar today={today} activeMonth={activeMonth} setActiveMonth={setActiveMonth} setShowCalendar={setShowCalendar} maxDate={maxDate}/>
                            </div>
                        )
                        }

                        {showHour && (
                                <div id="containerHourTopBarPhone"  className="containerHourTopBar smallTextBold primaryBack" ref={refHourPhone}>
                                    {timeSlots.map((time, index) => (
                                        <div
                                            key={index}
                                            id={`time-${time.replace("h", "-")}`}
                                            className={`timeSlot ${time === hour_selected && 'select'}`}
                                            onClick={() => {
                                                clearTimeFilters(setFilterChoose,filterChoose)
                                                setHour_selected(time === hour_selected ? '' : time);
                                                setShowHour(false);
                                            }}
                                        >
                                            {time}
                                        </div>
                                    ))}
                                </div>
                        )}
                        
                    </div>
                </div> 
                <div className="containerSearchBar">
                        <div className={`containerInputCity ${showCity &&  'select'}`} onClick={handleClickCity} ref={refCity}>
                            
                            <FaMapMarkerAlt color="black" opacity="85%" size={18} />
                            <input type="search" className="inputTopBar inputCity midText" id={"inputCity"} placeholder="Ville ..." style={{backgroundColor:"transparent"}} value={valueSearchCity} onChange={changeSearchCityBar} onBlur={blurSearchCityBar} maxLength={50} autoComplete="new-password" name="q_addr" onFocus={(e) => {e.currentTarget.setAttribute('autocomplete', 'new-password');setShowSearch(false)}}/>
                        
                             {valueSearchCity && (
                            <TfiClose className="resetTopBar pointer" size={13} onClick={(e) => {e.stopPropagation();e.preventDefault();clearProximity(setFilterChoose,filterChoose);  navigate('/');setValueSearchCity(""); setSearchCity("");setCoordonates({latitude:"",longitude:""}) }}/>)} 
                        </div>
                       
                        <div className="separation"></div>
                        <div className={`containerInputTopBar ${showSearch &&  'select'}`} onClick={handleClickInput} ref={refSearch}>
                                <GoSearch color="black" className="searchIcon" size={20} />
                                <input type="search" className='inputTopBar midText' placeholder={isSmallScreen ? "Rechercher..." : "Rechercher un restaurant..."} style={{backgroundColor:"transparent"}} value={valueSearchBar} onChange={changeSearchBar} onKeyDown={inputSearchKeyDown} maxLength={50}/>
                                  {valueSearchBar && (
                                    
                                        <TfiClose className="resetTopBar pointer" size={15} onClick={() => {setValueSearchBar("");changeSearchTopBar('')}}/>  )}

                                {
                                    showSearch && suggestions.length > 0 && <div className="containerSuggestion primaryBack" ref={refSearch}>
                                        <ContainerSuggestion suggestions={suggestions} />
                                    </div>
                                }
                        </div>
                        <div className="separation"></div>

                        <div className="icon" ref={refIconCalendar} >
                           <div className= "TopBarSelector pointer lowOpacityHover" onClick={handleCalendar}> 
                            <PiCalendarDotsLight color="black" size={20} />
                            <p className="smallText" style={{userSelect:'none'}}>{formatSelectedDate(date_selected)}</p>
                            </div> 
                            {date_selected && (
                                
                                <TfiClose
                                    className="resetTopBar pointer"
                                    size={13}
                                    onClick={() => {
                                        clearTimeFilters(setFilterChoose,filterChoose)
                                        setDate_selected(null);
                                        setShowCalendar(false);
                                    }}
                                />
                            )}
                        </div>


                        {
                        showCalendar && (
                            <div className="containerCalendar" ref={refCalendar}>
                                <ContainerCalendar today={today} activeMonth={activeMonth} setActiveMonth={setActiveMonth} setShowCalendar={setShowCalendar} maxDate={maxDate}/>
                            </div>
                        )
                        }

                        <div className="separation"></div>
                        <div className="icon" ref={refIconHour}>
                            <div className="TopBarSelector pointer lowOpacityHover" onClick={() => setShowHour(!showHour)}>
                                <CiClock2 color="black" size={18}  />
                                <p className="smallText" style={{userSelect:'none'}}>{hour_selected || "Heure"}</p>
                            </div>
                            
                            {hour_selected && (
                                <TfiClose
                                    className="resetTopBar pointer"
                                    size={13}
                                    onClick={() => {
                                        clearTimeFilters(setFilterChoose,filterChoose)
                                        setHour_selected("");
                                        setShowHour(false);
                                    }}
                                />
                            )}
                        </div>
                        {showHour && (
                                <div id="containerHourTopBar" className="containerHourTopBar smallTextBold primaryBack" ref={refHour}>
                                    {timeSlots.map((time, index) => (
                                        <div
                                            key={index}
                                            id={`time-${time.replace("h", "-")}`}
                                            className={`timeSlot ${time === hour_selected && 'select'}`}
                                            onClick={() => {
                                                clearTimeFilters(setFilterChoose,filterChoose)
                                                setHour_selected(time === hour_selected ? '' : time);
                                                setShowHour(false);
                                            }}
                                        >
                                            {time}
                                        </div>
                                    ))}
                                </div>
                            )}
                        
                    {showCity && <div className="containerListCity smallText" ref={refCity}>
                            <ContainerShowCity setSearchCity={setValueSearchCity} clickProximity={clickProximity} suggestionsCity={suggestionsCity} setShowCity={setShowCity} clearProximity={() => {clearProximity(setFilterChoose,filterChoose)}}/>
                        </div>
                    }
            
                </div>

                <IconConnection pointerClick={lockKeepClosedBriefly}/>
                
                <div className="TopLeftIconHome" style={{opacity: chevron ? 1 : 0.4}}>
                    {open ? 
                        <FiChevronUp size={30} onClick={handleToggleManually}/> : <FiChevronDown size={30} onClick={handleToggleManually}/> }
                </div>
            </div>   

            <div className="filterOnglet primaryBack"  >
                <div onClick={handleClick}>
                    <LiaSlidersHSolid size={25} />
                    <p className="smallTextBold">Filtres</p>
                </div>
                <div style={{marginRight:'1em'}} onClick={handleMap} > 
                <ImMap2 size={20} />
                    <p className="smallTextBold">Map</p>
                </div>

            </div> 
            {activeTopBar && <div className="maskBody"></div>}
        </div>
    )
}

export default TopBar